(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var backdrop = drawer.querySelector('.rg-cart-drawer__backdrop');
  var itemsList = drawer.querySelector('[data-cart-drawer-items]');
  var emptyState = drawer.querySelector('[data-cart-drawer-empty]');
  var countEls = document.querySelectorAll('[data-cart-drawer-count]');
  var badgeEls = document.querySelectorAll('[data-cart-count-badge]');
  var totalEl = drawer.querySelector('[data-cart-drawer-total]');
  var totalCompareEl = drawer.querySelector('[data-cart-drawer-total-compare]');
  var savingsWrap = drawer.querySelector('[data-cart-drawer-savings]');
  var savingsAmountEl = drawer.querySelector('[data-cart-drawer-savings-amount]');
  var promoEl = drawer.querySelector('[data-cart-promo]');
  var promoActionEl = drawer.querySelector('[data-cart-promo-action]');
  var checkoutLink = drawer.querySelector('[data-cart-checkout]');
  var discountInput = drawer.querySelector('[data-cart-discount-input]');
  var discountApplyBtn = drawer.querySelector('[data-cart-discount-apply]');
  var template = document.getElementById('rg-cart-drawer-item-template');
  var closers = drawer.querySelectorAll('[data-drawer-close]');
  var openTriggers = document.querySelectorAll('[data-cart-drawer-open]');
  var errorEl = drawer.querySelector('[data-cart-drawer-error]');

  var moneyFormat = window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : '';

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return '₹' + Number(amount).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function openDrawer() {
    drawer.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    window.setTimeout(function () {
      drawer.hidden = true;
    }, 280);
  }

  function updateBadges(count) {
    countEls.forEach(function (el) {
      el.textContent = count;
    });
    badgeEls.forEach(function (el) {
      el.textContent = count;
    });
  }

  // Reflect whether the promo code is already on the cart, so the card shows
  // "Applied" instead of inviting another click.
  function updatePromo(cart) {
    if (!promoEl) return;
    var code = (promoEl.getAttribute('data-code') || '').toUpperCase();
    // /cart.js exposes discount_codes ({ code, applicable }) and
    // cart_level_discount_applications ({ title }) -- not discount_applications.
    var applied = (cart.discount_codes || []).some(function (d) {
      return (d.code || '').toUpperCase() === code && d.applicable !== false;
    });
    if (!applied) {
      applied = (cart.cart_level_discount_applications || []).some(function (d) {
        return (d.title || '').toUpperCase() === code;
      });
    }
    promoEl.classList.toggle('is-applied', applied);
    if (promoActionEl) promoActionEl.textContent = applied ? 'Applied ✓' : 'Apply';
  }

  function renderItems(cart) {
    itemsList.innerHTML = '';

    if (cart.items.length === 0) {
      emptyState.hidden = false;
      itemsList.hidden = true;
      return;
    }

    emptyState.hidden = true;
    itemsList.hidden = false;

    var totalSavings = 0;

    cart.items.forEach(function (item) {
      var node = template.content.cloneNode(true);
      var li = node.querySelector('.rg-cart-drawer__item');
      li.setAttribute('data-line-key', item.key);

      var imageLink = node.querySelector('.rg-cart-drawer__item-image');
      var img = imageLink.querySelector('img');
      imageLink.href = item.url;
      if (item.image) {
        img.src = item.image.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '_x64$1$2');
        img.alt = item.product_title;
      }

      var titleLink = node.querySelector('.rg-cart-drawer__item-title');
      titleLink.href = item.url;
      titleLink.textContent = item.product_title;

      var variantEl = node.querySelector('.rg-cart-drawer__item-variant');
      if (item.variant_title && item.variant_title !== 'Default Title') {
        variantEl.textContent = item.variant_title;
      } else {
        variantEl.remove();
      }

      node.querySelector('[data-cart-qty-value]').textContent = item.quantity;

      var priceEl = node.querySelector('[data-cart-item-price]');
      priceEl.textContent = formatMoney(item.final_line_price);

      var compareEl = node.querySelector('[data-cart-item-compare]');
      if (item.original_line_price > item.final_line_price) {
        compareEl.textContent = formatMoney(item.original_line_price);
        compareEl.hidden = false;
        totalSavings += item.original_line_price - item.final_line_price;
      }

      itemsList.appendChild(node);
    });

    if (totalSavings > 0) {
      savingsWrap.hidden = false;
      savingsAmountEl.textContent = formatMoney(totalSavings);
    } else {
      savingsWrap.hidden = true;
    }
  }

  function renderTotals(cart) {
    totalEl.textContent = formatMoney(cart.total_price);
    if (cart.original_total_price && cart.original_total_price > cart.total_price) {
      totalCompareEl.textContent = formatMoney(cart.original_total_price);
      totalCompareEl.hidden = false;
    } else {
      totalCompareEl.hidden = true;
    }
    updatePromo(cart);
  }

  function render(cart) {
    updateBadges(cart.item_count);
    renderItems(cart);
    renderTotals(cart);
  }

  function showError(message) {
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = false;
    window.clearTimeout(showError._t);
    showError._t = window.setTimeout(function () {
      errorEl.hidden = true;
    }, 3500);
  }

  function fetchCart() {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(render)
      .catch(function () {});
  }

  function changeLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw err;
          });
        }
        return res.json();
      })
      .then(render)
      .catch(function (err) {
        showError((err && err.message) || 'Could not update quantity.');
        fetchCart();
      });
  }

  function quickAdd(variantId, button) {
    button.disabled = true;
    var originalText = button.textContent;
    button.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw err;
          });
        }
        return res.json();
      })
      .then(function () {
        button.textContent = 'Added ✓';
        fetchCart();
        window.setTimeout(function () {
          button.textContent = originalText;
          button.disabled = false;
        }, 1500);
      })
      .catch(function (err) {
        showError((err && err.message) || 'Could not add this item.');
        button.textContent = originalText;
        button.disabled = false;
      });
  }

  openTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      openDrawer();
    });
  });

  closers.forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  itemsList.addEventListener('click', function (event) {
    var li = event.target.closest('.rg-cart-drawer__item');
    if (!li) return;
    var key = li.getAttribute('data-line-key');
    var qtyEl = li.querySelector('[data-cart-qty-value]');
    var qty = parseInt(qtyEl.textContent, 10);

    if (event.target.closest('[data-cart-qty-increase]')) {
      changeLine(key, qty + 1);
    } else if (event.target.closest('[data-cart-qty-decrease]')) {
      changeLine(key, Math.max(0, qty - 1));
    } else if (event.target.closest('[data-cart-item-remove]')) {
      changeLine(key, 0);
    }
  });

  drawer.querySelectorAll('[data-cart-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      quickAdd(btn.getAttribute('data-variant-id'), btn);
    });
  });

  // Applying a code without leaving the drawer: hitting /discount/<code> sets
  // Shopify's discount cookie, then re-fetching the cart picks up the new
  // totals. Falls back to a normal redirect if the fetch is blocked.
  function applyDiscount(code, onDone) {
    return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function () {
        return fetchCart();
      })
      .then(function () {
        if (onDone) onDone(true);
      })
      .catch(function () {
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
      });
  }

  if (promoEl) {
    promoEl.addEventListener('click', function () {
      if (promoEl.classList.contains('is-applied')) return;
      var code = promoEl.getAttribute('data-code');
      if (!code) return;
      if (promoActionEl) promoActionEl.textContent = 'Applying…';
      applyDiscount(code, function () {
        if (promoActionEl && !promoEl.classList.contains('is-applied')) {
          // Cart didn't report it (e.g. minimum not met) -- say so rather than
          // silently reverting to "Apply".
          promoActionEl.textContent = 'Apply';
          showError('Could not apply ' + code + ' to this cart.');
        }
      });
    });
  }

  if (discountApplyBtn && discountInput) {
    discountApplyBtn.addEventListener('click', function () {
      var code = discountInput.value.trim();
      if (!code) return;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    });
    discountInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        discountApplyBtn.click();
      }
    });
  }

  if (checkoutLink && discountInput) {
    checkoutLink.addEventListener('click', function (event) {
      var code = discountInput.value.trim();
      if (code) {
        event.preventDefault();
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
      }
    });
  }

  window.RGCartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    refresh: fetchCart
  };

  fetchCart();
})();
